module.exports = __webpack_public_path__ + "img/shareWhat.7573d89e.png";